<template>
  <div class="cliente-block w-full md:w-6 lg:w-4 xl:w-3 px-3">
    <div class="box">
      <div class="image-box"><img :src="item.imagem" alt=""></div>
      <div class="overlay-box">
        <div class="content" v-html="item.nome"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {};
  },
  props: {
    item: Object,
  },
  computed: {},
  watch: {},
  methods: {},
  created() {},
  mounted() {},
  unmounted() {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
  .cliente-block {
    position: relative;
    margin-bottom: 30px;
  }
  .cliente-block .box {
    position: relative;
    overflow: hidden;
  }
  .cliente-block .image-box {
    background: white;
    display: flex;
    justify-content: center;
  }
  .cliente-block .image-box img {
    max-width: 100%;
    width: 315px;
    height: 300px;
    object-fit: contain;
    display: block;
  }

.cliente-block .overlay-box {
  position: absolute;
  left: 0;
  top: 0;
  height: 0;
  width: 100%;
  background-color: #000;
  transition: all 500ms ease;
}
.cliente-block .box:hover .overlay-box {
  height: 100%;
}
.cliente-block .box::before {
  position: absolute;
  right: -70px;
  bottom: -70px;
  height: 0;
  width: 0;
  border-bottom: 70px solid #ffffff;
  border-left: 70px solid transparent;
  content: "";
  z-index: 1;
  transition: all 300ms ease;
}

.cliente-block .box:hover::before {
  right: 0;
  bottom: 0;
  transition-delay: 300ms;
}

.cliente-block .overlay-box .content {
  position: absolute;
  top: 50%;
  width: 100%;
  text-align: center;
  transform: translateY(-50%);
  opacity: 0;
  visibility: hidden;
  transition: all 300ms ease;
  display: block;
  font-size: 24px;
  line-height: 26px;
  color: #ffffff;
  font-weight: 500;
  margin-bottom: 5px;
}

.cliente-block .overlay-box .content::after {
  position: absolute;
  left: 0;
  right: 0;
  margin: 0 auto;
  bottom: -20px;
  height: 3px;
  width: 40px;
  background-color: #ffffff;
  content: "";
}

.cliente-block .box:hover .overlay-box .content {
  opacity: 1;
  visibility: visible;
  transition-delay: 500ms;
}
</style>
